import { CFBaseFormFieldTokens } from './';
export const captionColor = ({ hasErrors, validated, }) => {
    if (validated)
        return CFBaseFormFieldTokens.CAPTION_COLOR.VALIDATED;
    if (hasErrors)
        return CFBaseFormFieldTokens.CAPTION_COLOR.ERROR;
    return CFBaseFormFieldTokens.CAPTION_COLOR.DEFAULT;
};
export const rootZIndex = ({ rootZIndex = 1 }) => {
    return rootZIndex;
};
